import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import { Row, Col, Label, Input, InputGroup, TabContent } from "reactstrap";
import Select from "react-select";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import { templateHelper } from "../../../template/helpers/templateHelper";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import { setValueToNestedObject, deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import { UseTemplateButton, SetStyleToAllOfItsType, SetToAuto } from "../../components/UseTemplateButton";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import { calendarInvitationHandler } from "./CalendarInvitation.handler";
import { emailFonts } from "../../models/emailFonts/emailFonts";
import { ElementTabGroup, TextCustomedTabGroup } from "../../../../components/editor/tools/EditorTabGroup";
import { TagToolbar } from "../../../tags/containers/TagToolbar";
import Axios from "axios";
import { FormGroup } from "@material-ui/core";

class CalendarInvitationSettings extends React.Component {
  state = {
    spreadActiveSet: [],
    invitations: [],
    activeTab: new Array(2).fill("1"),
  };

  componentDidMount() {
    this.fetchCalendarInvitations();
  }

  handleSoftUpdate = (element) => {
    const { dispatch } = this.props;
    dispatch(emailActions.updateEmailElement(element, null, true, this.props.inherit));
  };

  handleInput = (text) => {
    const { selectedElement } = this.props;
    let elementCopy = deepClone(selectedElement);
    elementCopy.style.elementProps.text = text;
    this.handleSoftUpdate(elementCopy);
  };

  handleChange = (val, name) => {
    const { selectedElement } = this.props;
    let elementCopy = deepClone(selectedElement);

    elementCopy.style.elementProps.link = `https://jirango.com/cms/api/calendar/geticalfile/${val}?badgeNo=[badgeNo]`;

    elementCopy.style.elementProps.text = `${name}.ical`;
    /*     elementCopy.style.elementProps.link = `<a href="https://localhost:44374/api/calendar/geticalfile/${val}?badgeNo=[badgeNo]" download="ical-inv"> IcalFile</a>`; */
    elementCopy.style.elementProps.invitationId = val;
    this.handleSoftUpdate(elementCopy);
  };

  fetchCalendarInvitations = () => {
    Axios.get(`./api/calendar/getCalendarInvites/${this.props.cms.eventId}`).then(({ data }) => {
      this.setState({
        invitations: data.map((d) => {
          return {
            value: d.calendarInviteId,
            label: d.name,
          };
        }),
      });
    });
  };

  render() {
    const { selectedElement, template } = this.props;
    const selectStyles = {
      option: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "12px",
          fontFamily: data.value,
          padding: "0 10px",
        };
      },
      container: (styles) => ({
        ...styles,
        minWidth: "100%",
        borderRight: "1px solid gainsboro",
      }),
      /*       control: styles => ({
                      borderWidth: '1px'
                  }), */
      singleValue: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "12px",
          fontFamily: data.value,
        };
      },
    };
    console.log(this.state.invitations);
    return (
      <React.Fragment>
        <div>
          <TextCustomedTabGroup activeTab={this.state.activeTab[0]} toggle={this.toggle} />
          <TabContent className="editor-tabcontent" style={{ paddingBottom: "65px" }} activeTab={this.state.activeTab[0]}>
            {this.state.activeTab[0] === "1" && (
              <ListExpansion footer={false} icon="fa fa-image" description="Settings" defaultExpanded={true}>
                <Row>
                  <Col className="list-setting-item-title">
                    <Label htmlFor="text-label">
                      <SystemLabel name={`SelectInvitation`} />
                    </Label>
                  </Col>
                </Row>
                <Row>
                  <Col className="list-setting-item-title" style={{ lineHeight: "unset" }}>
                    <InputGroup style={{ display: "inline-flex", flexWrap: "nowrap", alignItems: "unset", maxWidth: "100%" }}>
                      <Select
                        className="jirango-fontpicker no-prepend"
                        classNamePrefix="jirango-fontpicker"
                        options={this.state.invitations}
                        openMenuOnClick={() => null}
                        value={
                          selectedElement
                            ? {
                                value: selectedElement.style.elementProps.invitationId,
                                label: this.state.invitations.find((i) => i.value == selectedElement.style.elementProps.invitationId)?.label,
                              }
                            : null
                        }
                        onChange={(selectedOption) => this.handleChange(selectedOption.value, selectedOption.label)}
                        styles={selectStyles}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className="list-setting-item-title">
                    <FormGroup style={{ width: "100%" }}>
                      <Label htmlFor="text-label">
                        <SystemLabel name={`DisplayText`} />
                      </Label>
                      <Input id="text-label" autoComplete="jirango-nofill" value={selectedElement.style.elementProps.text || ""} onChange={(e) => this.handleInput(e.target.value)} />
                    </FormGroup>
                  </Col>
                </Row>
              </ListExpansion>
            )}
          </TabContent>
        </div>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    elements: state.email.elements,
    inherit: state.email.inherit,
    template: state.template.template,
    selectedElement: state.email.selectedElement,
    cms: state.cms,
  };
}
export default connect(mapStateToProps)(CalendarInvitationSettings);
